import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AnalyticsRoute extends Route {
  @service abilities;
  @service router;
  @service featureFlags;
  @service featureConfig;

  title = 'Analytics · Envoy';

  beforeModel() {
    if (this.abilities.can('visit occupancy-analytics')) {
      this.router.transitionTo('analytics.occupancy');
    } else if (this.abilities.can('visit-attendance analytic')) {
      this.router.transitionTo('analytics.attendance.overview');
    } else if (this.abilities.can('visit-attendance-by-employee analytic')) {
      this.router.transitionTo('analytics.attendance.report');
    } else if (this.abilities.can('visit-strategic-insights analytic')) {
      this.router.transitionTo('analytics.strategic-insights');
    } else if (this.abilities.can('visit-visitors analytic')) {
      this.router.transitionTo('analytics.visitors');
    } else if (this.abilities.can('visit protect-analytics')) {
      this.router.transitionTo('analytics.protect');
    } else if (this.abilities.can('visit-deliveries analytic')) {
      this.router.transitionTo('analytics.deliveries');
    } else if (this.abilities.can('visit-desks analytic') && this.featureConfig.isEnabled('desks.analytics')) {
      this.router.transitionTo('analytics.desks');
    } else if (this.abilities.can('visit-rooms analytic')) {
      this.router.transitionTo('analytics.rooms');
    } else if (this.abilities.can('visit-parking analytic')) {
      this.router.transitionTo('analytics.parking');
    } else if (this.abilities.can('visit-screens analytic')) {
      this.router.transitionTo('analytics.screens');
    } else if (this.abilities.can('visit occupancy-location-report')) {
      this.router.transitionTo('analytics.reports');
    } else if (this.abilities.can('visit-scheduled-exports analytic')) {
      this.router.transitionTo('analytics.scheduled-exports');
    } else {
      this.router.transitionTo('unauthorized');
    }
  }
}
